import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { PanelDatosTurno } from "./PanelDatosTurno";
import { BannerAfiliado } from "../../afiliaciones/BannerAfiliado";

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      padding:10,
      marginTop:20
    }
}));

export const AfiliadoTurno = ({autopercepcion, idObraSocial, setIdObraSocial}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>  
        <BannerAfiliado turnos={true} />
        <PanelDatosTurno autopercepcion={autopercepcion} idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial}/>
    </div>
  );

};
